import { Currency } from "@daytrip/legacy-enums";
import { Exclude, Expose } from "class-transformer";
import { IsDefined, IsUUID, IsString, IsEnum } from "class-validator";
import { v4 as uuid } from "uuid";

@Exclude()
export class MangopayBankAccountInformation {
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public _id: string = uuid();

    @IsString()
    @IsDefined()
    @Expose()
    public bankAccountId: string;

    @IsEnum(Currency)
    @Expose()
    public currency = Currency.Euro;
}
